import {
  DiscoveryProductsBestSellerGroupParametersType,
  DiscoveryProductsBestSellerGroupResponseType,
} from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDiscoveryProductBestsellersGroup = <
  TData = DiscoveryProductsBestSellerGroupResponseType,
>(
  params: DiscoveryProductsBestSellerGroupParametersType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.DiscoveryProductBestSellers,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `discovery/discovery-product-best-sellers/ssr/page`,
        params: {
          ...params,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
